import axios from "axios";
import toastCustom from "./toastCustom";
import utils from "./utils";

interface ApiHelpProps {
    url: string,
    data?: any,
    method?: 'POST' | 'GET' | 'DELETE' | 'PATCH',
    timezone?: any
    message?: string
    callback?: any
    ip?: any
}

export interface ResponseProps {
    message: string,
    status: number,
    response: boolean,
    dados: any
}

class ApiHelper {
    api_url = '';
    users = '';
    userFiltro = '';
    estados_all = '';
    cidades_uf = '';
    eventos = '';
    eventosPorId = '';
    eventosEdit = '';
    evento_add_banner = '';
    categoria = '';
    add_lote = '';
    areas = '';
    add_area = '';
    delete_area = '';
    delelte_lote = ''
    lotes = ''
    dadosImpressao = ''
    loteIngressos = ''
    dominio = process.env.NEXT_PUBLIC_URL_API
    areaLimiteDisiponvel = ''
    addCart = ''
    getCart = ''
    getIngressosCart = ''
    reservarIngresso = ''
    removeIntCart = ''
    reservaListar = ''
    finalizarReserva = ''
    pagamentoCard = ''
    pedidos = ''
    vendas = ''
    pedidoById = ''
    verificarStatus = ''
    addTitular = ''
    alterarTitular = ''
    ingressoImprimir = ''
    calculoParcelas = ''
    recuperarSenha = ''
    salvarNovaSenha = ''
    confirmarEmail = ''
    pagamentoManual = ''
    estornar = ''
    capturar = ''
    removerMesa = ''
    salvarCupom = ''
    deleteCupom = ''
    getCupons = ''
    getCupom = ''
    getCupomDetalhes = ''
    alterarSenha = ''
    ativarDesativarCupom = ''
    buscarUserPorNome = ''
    addInfluencer = ''
    getCuponsInfluencer = ''
    addPromotorEvento = ''
    getPromotorPorNome = ''
    pdv_ctrl = ''
    ponto_venda = ''
    getPontosVendas = ''
    addVendedorEmPdv = ''
    deleteVendedorDePdv = ''
    deletePDV = ''
    equipes = ''
    relatorios = ''
    pagamentoRetorno = ''
    roles = ''
    empresa = ''
    recaptcha = ''

    constructor() {
        this.api_url = this.dominio + "/api"
        this.users = this.api_url + "/users"
        this.estados_all = this.api_url + "/estado/all"
        this.cidades_uf = this.api_url + "/cidade/uf/"
        this.eventos = this.api_url + "/eventos"
        this.eventosPorId = this.api_url + "/eventos/por-id"
        this.eventosEdit = this.api_url + "/eventos/edit"
        this.categoria = this.api_url + "/categoria"
        this.evento_add_banner = this.api_url + "/eventos/add-banner"
        this.add_lote = this.api_url + "/eventos/add-lote"
        this.add_area = this.api_url + "/eventos/add-area"
        this.delete_area = this.api_url + "/eventos/delete-area"
        this.areas = this.api_url + "/eventos/get-areas"
        this.delelte_lote = this.api_url + "/eventos/delete-lote"
        this.lotes = this.api_url + "/eventos/lotes"
        this.dadosImpressao = this.api_url + "/eventos/dados-impressao"
        this.loteIngressos = this.api_url + "/eventos/lote-ingressos"
        this.areaLimiteDisiponvel = this.api_url + '/eventos/area-limite-disponivel'
        this.addCart = this.api_url + '/eventos/add-cart'
        this.getCart = this.api_url + '/eventos/get-cart'
        this.getIngressosCart = this.api_url + '/eventos/get-ingressos-cart'
        this.reservarIngresso = this.api_url + '/eventos/reservar-ingresso'
        this.removeIntCart = this.api_url + '/eventos/remove-item-cart'
        this.reservaListar = this.api_url + '/reserva/listar'
        this.finalizarReserva = this.api_url + '/reserva/finalizar'
        this.pagamentoCard = this.api_url + '/pagamento/card'
        this.pedidos = this.api_url + '/pagamento/pedidos'
        this.ingressoImprimir = this.api_url + '/pagamento/ingresso-imprimir'
        this.vendas = this.api_url + '/pagamento/vendas'
        this.pedidoById = this.api_url + '/pagamento/pedido'
        this.verificarStatus = this.api_url + '/pagamento/verificar-status'
        this.addTitular = this.api_url + '/eventos/add-titular-ingresso'
        this.alterarTitular = this.api_url + '/eventos/editar-titular-ingresso'
        this.calculoParcelas = this.api_url + '/pagamento/calculo-parcelas'
        this.recuperarSenha = this.api_url + '/users/recuperar-senha'
        this.salvarNovaSenha = this.api_url + '/users/salvar-nova-senha'
        this.confirmarEmail = this.api_url + '/users/confirmar-email'
        this.pagamentoManual = this.api_url + '/pagamento/manual'
        this.estornar = this.api_url + '/pagamento/estornar'
        this.capturar = this.api_url + '/pagamento/capturar'
        this.removerMesa = this.api_url + '/pagamento/remover-mesa'
        this.salvarCupom = this.api_url + '/eventos/salvar-cupom'
        this.deleteCupom = this.api_url + '/eventos/delete-cupom'
        this.getCupons = this.api_url + '/eventos/get-cupons'
        this.getCupom = this.api_url + '/eventos/get-cupom'
        this.getCupomDetalhes = this.api_url + '/eventos/get-cupom-detalhes'
        this.alterarSenha = this.users + '/alterar-senha'
        this.ativarDesativarCupom = this.eventos + '/ativar-desativar-cupom',
            this.buscarUserPorNome = this.users + '/find-by-name'
        this.addInfluencer = this.eventos + '/add-influencer-cupom'
        this.getCuponsInfluencer = this.eventos + '/get-cupons-influencer'
        this.addPromotorEvento = this.users + '/add-promotor-eventos'
        this.userFiltro = this.users + '/filtrar'
        this.getPromotorPorNome = this.users + '/get-promotores-por-nome'
        this.ponto_venda = this.eventos + '/pdv'
        this.getPontosVendas = this.ponto_venda + '/por-evento'
        this.addVendedorEmPdv = this.ponto_venda + '/add-vendedor'
        this.deleteVendedorDePdv = this.ponto_venda + '/delete-vendedor'
        this.deletePDV = this.ponto_venda + '/delete-pdv'
        this.equipes = this.api_url + '/equipe'
        this.relatorios = this.api_url + '/relatorios'
        this.pagamentoRetorno = this.api_url + '/pagamento/retorno'
        this.roles = this.api_url + '/roles'
        this.empresa = this.api_url + '/empresa'
        this.pdv_ctrl = this.api_url + "/ponto-venda"
        this.recaptcha = this.api_url + "/recaptcha/verify"
    }

    async post(props: ApiHelpProps): Promise<ResponseProps> {
        return new Promise<ResponseProps>(async (resolve, reject) => {
            const fuso = utils.getCookie('fuso')

            var header: any = {
                'api-token': process.env.NEXT_PUBLIC_API_TOKEN,
                'timezone': !props.timezone ? utils.getTimezone() : props.timezone,
                'ip_client': props.ip ?? ''
            }

            await axios({
                url: props.url,
                method: props.method,
                data: props.data,
                headers: header
            }).then((res) => {
                const result: ResponseProps = res.data

                if (result.response) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }).catch((err) => {
                if ('response' in err) {
                    const result: ResponseProps = err.response.data
                    reject(result)
                } else {
                    reject(err.toString())
                }
            })
        })
    }

    async buscaCep(txt: string) {
        return new Promise<any>(async (resolve, reject) => {
            txt = txt.replaceAll('_', '');
            txt = txt.replace('-', '')
            if (txt.length == 8) {
                const url = 'https://viacep.com.br/ws/' + txt + '/json/'

                await axios({
                    url: url,
                    method: 'GET',
                }).then((res) => {
                    resolve(res.data)
                }).catch((err) => {
                    reject(err)
                })
            }
            return null
        })
    }

    async postToast({method, url, data, message, callback}: ApiHelpProps) {
        try {
            const res = await this.post({
                method: method ? method : 'POST',
                url: url,
                data
            })

            if (res.response) {
                callback(res.dados)

                toastCustom.show({
                    mensagem: message ?? 'Operação efetuada com sucesso',
                    type: 'success'
                })
            } else {
                toastCustom.show({
                    mensagem: res.dados,
                    type: 'warning'
                })
            }
        } catch (e: any) {
            toastCustom.show({
                mensagem: e.message,
                type: 'error'
            })
            callback({error: e.toString()})
        }
    }
}

export default new ApiHelper()